import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectTags, orderedTags } from 'store/Tags/selectors';
import TagsModal from 'Common/Components/TagsModal';
import {
  selectExploreGroupSelectedServiceObjects,
  selectExploreGroupSelectedServicesTags
} from 'store/GroupVulns/selectors';
import {
  addExploreGroupServiceTag,
  removeExploreGroupServiceTag,
  setExploreGroupServiceNewTags
} from 'store/GroupVulns/actions';

const ExploreGroupServicesTagsModal = () => {
  const dispatch = useDispatch();
  const wsTags = useSelector(selectTags);
  const selectedServices = useSelector(selectExploreGroupSelectedServiceObjects);
  const servicesTags = useSelector(selectExploreGroupSelectedServicesTags);
  const tags = useSelector((state) => orderedTags(state, servicesTags, selectedServices));

  const onClickTag = (tag) => {
    if (tag.partialSelected) {
      dispatch(addExploreGroupServiceTag(tag.name));
    } else {
      if (tag.addedToVuln) dispatch(removeExploreGroupServiceTag(tag.name));
      else dispatch(addExploreGroupServiceTag(tag.name));
    }
  };

  const addTags = (newTags) => {
    dispatch(setExploreGroupServiceNewTags(newTags));
  };

  return (
    <TagsModal tags={ tags } onClickTag={ onClickTag } addTags={ addTags } allTags={ wsTags } entity="exploreGroupServices" />
  );
};

export default ExploreGroupServicesTagsModal;
